import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-add-modale',
  templateUrl: './image-add-modale.component.html',
  styleUrls: ['./image-add-modale.component.scss']
})
export class ImageAddModaleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
